import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function SideBar() {

    const location = useLocation();
    const navigate = useNavigate();

    const menuItems = [
        {
            id: "dashboard",
            label: "DASHBOARD",
            icon: "dash",
            path: "/club/dashboard",
        },
        {
            id: "marketplace",
            label: "MARKETPLACE",
            icon: "home",
            path: "/club/marketplace",
        },
    ];

    const [openToggle, setOpenToggle] = useState(false);

    const handleOpen = () => {
        setOpenToggle(!openToggle)
    }

       const handleLogout = () => {
        sessionStorage.removeItem("club_token");
        navigate("/");
    };


    return (
        <>
            <div className='hidden lg:block bg-black text-white lg:w-[10%] py-5 px-3'>
                <div className='grid content-between h-full'>
                    <div className='grid gap-3'>
                        <img src='/assets/logo/GLX_NEW_WT BG_Low.png'></img>
                        <div className='mt-3'>
                            {menuItems.map((item) => {
                                const isActive = location.pathname === item.path;
                                return (
                                    <Link to={item.path} key={item.id}>
                                        <div
                                            className={`flex flex-col items-center gap-3 py-3 px-5 cursor-pointer transition-all duration-300 text-sm 
                                ${isActive ? "text-[#24FF00] font-medium" : "text-white"}`}>
                                            <img
                                                src={`/assets/icon/${isActive ? `${item.icon}.svg` : `${item.icon}white.svg`}`}
                                                alt={item.label}
                                                className="w-5 h-5"
                                            />
                                            <span>{item.label}</span>
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                    <div className='flex flex-col gap-5 items-center text-xl cursor-pointer'  onClick={handleLogout}>
                        <FontAwesomeIcon icon={faArrowRightFromBracket} />
                    </div>
                </div>
            </div>
            <div className={`block lg:hidden bg-black text-white lg:w-[10%] transition-all duration-500 ease-in-out ${openToggle ? 'max-h-[500px] py-5' : 'max-h-0 py-0 overflow-hidden'}`}>
                {menuItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                        <Link to={item.path} key={item.id}>
                            <div
                                className={`flex items-center gap-5 py-3 px-5 cursor-pointer transition-all duration-300 
                                ${isActive ? "text-[#24FF00] font-medium" : "text-white"}`}>
                                <img
                                    src={`/assets/icon/${isActive ? `${item.icon}.svg` : `${item.icon}white.svg`}`}
                                    alt={item.label}
                                    className="w-5 h-5"
                                />
                                <span>{item.label}</span>
                            </div>
                        </Link>
                    );
                })}
            </div>
            <div className='block lg:hidden px-5 pt-5'>
                <div className='flex flex-col gap-1 curser-pointer' onClick={handleOpen}>
                    <div className={`duration-500 h-[2px] bg-gray-200 ${openToggle ? 'w-6 rotate-45 translate-y-1' : 'w-7'}`}></div>
                    <div className={`duration-500 h-[2px] bg-gray-200 ${openToggle ? 'w-6 -rotate-45 -translate-y-0.5' : 'w-5'}`}></div>
                </div>
            </div>
        </>
    )
}
